import React from 'react';
import { Link } from 'react-router-dom';
import { ADMIN_LINKS, TEAMS_ADMIN_LINK, showEventsAdmin } from './AdminPanelShell';

const ADMIN_GROUPS = [
    {
        title: 'Go Live',
        links: [{ label: 'Go-Live Panel', path: '/admin/go-live', blurb: 'Test or Live for each module, the test list, the Test Outbox and the change history' }],
    },
    {
        title: 'Organization',
        links: ['Brands & Locations', { label: 'Company Words', path: '/admin/company-words', blurb: 'What your team and clients call a booking (Engagements, Reservations…)' }, 'Billing & Financials'],
    },
    {
        title: 'People',
        links: ['Staff & Roles', 'Applicant Pipeline'],
    },
    {
        title: 'Communications',
        links: ['Notification Defaults', 'Phone Numbers', 'Email Mailboxes', 'Calendar Connections', 'Business Schedule', 'Client Invitations', 'Templates', 'Signatures', 'Customer Consent'],
    },
    {
        title: 'Dispatch',
        links: [{ label: 'Group Transfers', path: '/admin/dispatch/group-transfers', blurb: 'Grouping, automation, capacity and flight re-checks' },
            { label: 'Zones', path: '/admin/dispatch/zones', blurb: 'Rings around a center point and ZIP codes, with drive minutes to the airport' },
            { label: 'Traffic chart', path: '/admin/dispatch/traffic-chart', blurb: 'Extra minutes by day and time for airport departure runs' }],
    },
    {
        title: 'Data Quality',
        links: ['Possible Duplicates'],
    },
    {
        title: 'Monitoring',
        links: ['Reports & Logs', 'Support Access'],
    },
];

// Module 19 G8: the Events group appears only while the Events pack is on for this organization (and this page is Admin only).
export const EVENTS_ADMIN_GROUP = { title: 'Events', links: [{ label: 'Events Settings', path: '/admin/events', blurb: 'Defaults, event types, guests and who can plan events' }] };

// Teams PR A: the Integrations group holds one tile per built-in integration the organization opted in to (Tenant Admins only).
export const INTEGRATIONS_ADMIN_GROUP = {
    title: 'Integrations',
    links: [{ ...TEAMS_ADMIN_LINK, blurb: 'Teams mirroring: on or off, who gets it, and what it may use' }],
};

// EV-fix-1: same rule as the Admin Center menu (showEventsAdmin) - the group appears once the flag has resolved to on, never while it loads.
export default function AdminCenterHome({ theme = 'light', eventsEnabled = false, eventsLoading = false, teamsEnabled = false }) {
    const base = showEventsAdmin({ eventsEnabled, eventsLoading }) ? [...ADMIN_GROUPS, EVENTS_ADMIN_GROUP] : ADMIN_GROUPS;
    const groups = teamsEnabled ? [...base, INTEGRATIONS_ADMIN_GROUP] : base;
    return (
        <section data-theme={theme} aria-labelledby="admin-tools-heading">
            <div className="mb-6">
                <h2 id="admin-tools-heading" className="text-lg font-semibold text-[var(--ink)]">
                    Admin Centers
                </h2>
                <p className="mt-1 text-sm text-[var(--ink-muted)]">
                    Manage organization-wide settings, people, communications, and access.
                </p>
            </div>
            <div className="grid gap-5 xl:grid-cols-2">
                {groups.map((group) => (
                    <section
                        key={group.title}
                        aria-label={group.title}
                        className="rounded-lg border border-[var(--surface-border)] bg-[var(--surface-raised)] p-4"
                    >
                        <h3 className="mb-3 border-b border-[var(--surface-border)] pb-2 text-sm font-semibold uppercase tracking-wide text-[var(--ink-muted)]">
                            {group.title}
                        </h3>
                        <div className="grid gap-2 sm:grid-cols-2">
                            {group.links.map((entry) => {
                                const label = typeof entry === 'string' ? entry : entry.label;
                                const destination = typeof entry === 'string' ? ADMIN_LINKS.find((link) => link.label === entry) : entry;
                                return (
                                    <Link
                                        key={label}
                                        to={destination.path}
                                        className="rounded-md border border-transparent p-3 text-[var(--ink)] transition hover:border-[var(--surface-border)] hover:bg-[var(--surface-sunken)]"
                                    >
                                        <span className="font-medium">{label}</span>
                                        <span className="mt-1 block text-xs text-[var(--ink-muted)]">
                                            {destination.blurb || `Open ${label.toLowerCase()} settings`}
                                        </span>
                                    </Link>
                                );
                            })}
                        </div>
                    </section>
                ))}
            </div>
        </section>
    );
}
